/**
 * ExchangeRate Mutations
 * Mutations para crear o actualizar tipos de cambio en la API
 */

/**
 * Mutation para crear o actualizar un tipo de cambio
 */
export const SAVE_EXCHANGE_RATE = `
    mutation SaveExchangeRate($exchangeRate: inputExchangeRate!) {
          saveExchangeRate(input: $exchangeRate) {
              id
              exchangeDate
              sellRate
              buyRate
              closingBuyRate
              closingSellRate
              createdAt
              updatedAt
          }
    }
`;